import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { getSelectorAttribute, integrationsPageSelectors } from '@vy/app-selectors';
import { VyIcon } from '@vy/ui-design-system';
import { type FC, type ReactNode } from 'react';
import { CardAction } from './components/CardActions';
import { CardHeader } from './components/CardHeader';

type IntegrationCardProps = {
  title: string;
  serviceType: string;
  description: string;
  supported: boolean;
  logo: ReactNode;
  imageLogo?: boolean;
  isConnected?: boolean;
  onClick: () => void;
};

export const IntegrationCard: FC<IntegrationCardProps> = ({
  title,
  serviceType,
  description,
  supported,
  logo,
  imageLogo,
  onClick,
  isConnected = false,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        height: '100%',
        minHeight: '210px',
        borderRadius: '10px',
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
      }}
      {...getSelectorAttribute(integrationsPageSelectors.card.root)}
    >
      <CardContent sx={{ p: 0, flexGrow: 1 }}>
        <Stack spacing={2}>
          <CardHeader
            title={title}
            subtitle={`${serviceType} service`}
            logo={logo}
            imageLogo={imageLogo}
            showConnectedBadge={isConnected}
            showNotSupportedBadge={!supported}
          />

          <Typography variant="body2" sx={{
            color: "text.primary"
          }}>
            {description}
          </Typography>
        </Stack>
      </CardContent>
      {isConnected ? (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
            justifyContent: "flex-end"
          }}>
          <Button
            variant="text"
            startIcon={<VyIcon icon="Settings" />}
            sx={{ color: '#020F20', fontSize: '14px', fontWeight: 500 }}
            onClick={onClick}
            {...getSelectorAttribute(integrationsPageSelectors.card.manageButton)}
          >
            Manage
          </Button>
        </Stack>
      ) : (
        <CardAction disabled={!supported} onConnectClick={onClick} />
      )}
    </Card>
  );
};
